import React from "react";
import { Box, Typography } from "@mui/material";
import FilterDropdown from "./FilterDropdown";
import FilterListIcon from "../../../assets/images/FilterImg.svg";
import useFilterSelections from "./useFilterSelections";

interface FilterOption {
  id: string;
  label: string;
}

interface FilterOptions {
  yearOptions: FilterOption[];
  monthOptions: FilterOption[];
  mrNameOptions: FilterOption[];
}

interface CallsFilterCardProps {
  showExtraFilter?: boolean;
  filterOptions: FilterOptions;
}

const CallsFilterCard: React.FC<CallsFilterCardProps> = ({ filterOptions }) => {
  const {
    selectedYearIds,
    selectedMonthIds,
    selectedMrIds,
    handleYearFilterChange,
    handleMonthFilterChange,
    handleMrFilterChange,
    error,
  } = useFilterSelections({
    filterOptions,
    endpoint: "MyPerformance/MyPerformanceCoverage",
    isCallsFilter: true,
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        borderRadius: "0",
        padding: 1,
        justifyContent: "space-between",
        margin: "0 auto",
        borderBottom: "2px solid #F5F5F5",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontSize: "24px",
          fontWeight: "bold",
          marginRight: 2,
          minWidth: "50px",
        }}
      >
        Calls
      </Typography>

      <Box sx={{ display: "flex" }}>
        <FilterDropdown
          items={filterOptions.yearOptions}
          onFilterChange={handleYearFilterChange}
          placeholder="Select items..."
          FiterLabel="Year"
          initialSelectedIds={selectedYearIds}
        />
        <FilterDropdown
          items={filterOptions.monthOptions}
          onFilterChange={handleMonthFilterChange}
          placeholder="Select items..."
          FiterLabel="Month"
          initialSelectedIds={selectedMonthIds}
        />
        <FilterDropdown
          items={filterOptions.mrNameOptions}
          onFilterChange={handleMrFilterChange}
          placeholder="Select items..."
          FiterLabel="MR Name"
          initialSelectedIds={selectedMrIds}
        />
        <img src={FilterListIcon} alt="Filter Icon" className="callfilter-icon" />
      </Box>

      {error && (
        <Typography color="error" sx={{ mt: 1 }}>
          Error: {error}
        </Typography>
      )}
    </Box>
  );
};

export default CallsFilterCard;